const baseInputStyles = (theme) => ({
  backgroundColor: 'transparent',
  fontFamily: 'var(--root-font) !important',
  width: '100%',
  border: 'none',
  '&:focus': {
    outline: 'none'
  },
  '&::placeholder': {
    opacity: '0.2',
    fontWeight: 'bold'
  }
})

const sizes = {
  xs: (theme) => ({
    padding: '0 10px 0 0',
    minHeight: '32px',
    '& > input': {
      ...baseInputStyles(theme),
      lineHeight: '24px',
      fontSize: theme.typography.fontSizes.lg
    },
    '& .MuiInputAdornment-positionStart': {
      marginRight: '4px'
    },
    '& .MuiIconButton-root': {
      padding: '6px',
      '& .MuiSvgIcon-root': {
        width: '0.75em',
        height: '0.75em'
      }
    }
  }),
  sm: (theme) => ({
    padding: '2px 10px 2px 0',
    minHeight: '40px',
    '& > input': {
      ...baseInputStyles(theme),
      lineHeight: '32px',
      fontSize: theme.typography.fontSizes.xl
    }
  }),
  lg: (theme) => ({
    padding: '10px 10px 10px 0',
    minHeight: '54px',
    '& > input': {
      lineHeight: '32px',
      ...baseInputStyles(theme),
      fontSize: theme.typography.fontSizes.xl
    }
  })
}

export const mapInputStyles = (theme, rest) => ({ disabled, size }) => ({
  ...rest,
  ...sizes[size](theme),
  backgroundColor: disabled ? 'var(--color-neutral-300)' : 'var(--color-surface-050)'
})
